import React from 'react'

const ListIcon = props => {
  return (
    <svg
      width="16"
      height="10"
      viewBox="0 0 16 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="list view"
      id="icon_view"
    >
      <title>List View</title>
      <rect width="4" height="4" fill="white" />
      <rect x="6" width="10" height="4" fill="white" />
      <rect y="6" width="4" height="4" fill="white" />
      <rect x="6" y="6" width="10" height="4" fill="white" />
    </svg>
  )
}

export default ListIcon
